import { useQuery } from '@tanstack/react-query';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { ITS_FIELD_LABELS } from '../../util/ITS';

const FilterModalItsDataFetch = (props) => {
  const [coded_values, setCoded_values] = useState(null);
  const { gis_service, option, setFieldValue } = props;
  let feature_url = `https://sparcal.sdsc.edu/geoserver/wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${gis_service.layer_name}&propertyName=${option.name}`;
  const [selectedOptions, setSelectedOptions] = useState([]);

  const { isLoading } = useQuery({
    queryKey: [option.name],
    queryFn: async () => {
      const response = await fetch(feature_url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const text_xml = await response.text();

      const xmlDoc = await new window.DOMParser().parseFromString(
        text_xml,
        'text/xml'
      );

      const namespace = gis_service.layer_name.split(':')[0];

      const element_val = xmlDoc.getElementsByTagName(
        namespace + ':' + option.name
      );
      const element_list = Array.from(element_val);

      const values = element_list.map((val) => val.textContent);
      const unique = [...new Set(values)];
      unique.sort();

      const uniqueValue = unique
        .filter((value) => value !== '')
        .map((value) => {
          return { value: value, label: value };
        });

      option.coded_values = unique;
      setCoded_values(uniqueValue);
      return option;
    },
  });

  useEffect(() => {
    if (!option?.value) return;
    const dataMap = option.value.map((value) => {
      return { value: value, label: value };
    });
    setSelectedOptions(dataMap);
  }, []);

  const handleOnChange = (value) => {
    const saveFormat = value.map((item) => {
      return item.value;
    });
    setFieldValue(option.name, saveFormat);
  };

  const getLabel = (label) => {
    return ITS_FIELD_LABELS[label] ? ITS_FIELD_LABELS[label] : label;
  };

  return (
    <Form.Group id={option.name}>
      <Form.Label>
        <span
          dangerouslySetInnerHTML={{
            __html: getLabel(option.label),
          }}
        ></span>
      </Form.Label>
      <Select
        isDisabled={isLoading}
        isMulti
        value={selectedOptions || []}
        options={coded_values || []}
        onChange={(event) => {
          setSelectedOptions(event);
          handleOnChange(event);
        }}
      />
    </Form.Group>
  );
};
export default FilterModalItsDataFetch;
